if (!customElements.get("td-modal")) {
    class TDModal extends HTMLElement {
        constructor() {
            super();
            this.MODAL_CLOSE_CLASS = '.materialModal__closer';
            this.CONTAINER_CLASS = '.materialModal'

            this.modalCloseButton = this.querySelector(this.MODAL_CLOSE_CLASS);
            this.modalContainer = this.querySelector(this.CONTAINER_CLASS);
        }
    
        connectedCallback() {
            this.modalCloseButton.addEventListener('click', () => {
                this.closeModal()
            });
            this._handleOutsideClick = this._handleOutsideClick.bind(this);
        }

        closeModal() {
            if (!this.modalContainer.classList.contains('materialModal__hide')) {
                this.modalContainer.classList.add('materialModal__hide');
            }
            document.documentElement.classList.remove('td-modal-open');
            document.removeEventListener('click', this._handleOutsideClick, true);
        }

        openModal() {
            if (this.modalContainer && this.modalContainer.classList.contains('materialModal__hide')) {
                this.modalContainer.classList.remove('materialModal__hide');
            }
            document.documentElement.classList.add('td-modal-open');
            document.addEventListener('click', this._handleOutsideClick, true);
        }

        _handleOutsideClick(event) {
            if (
                !event.target.closest('.materialModal-swatch__wrapper') &&
                !event.target.closest('.materialModal__wrapper')
            ) {
                this.closeModal();
            }
        }
    }

    customElements.define("td-modal", TDModal);
}
